import React, { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { v4 as uuidv4 } from 'uuid'
import { Formik, Field, FormikErrors, FormikHelpers } from 'formik'
import { GiftMessageFormValues } from 'lib/core/hooks/useGiftMessageForm'
import { Form, Grid } from 'lib/ui'
import { schema, validation } from './schema'

export type OnSubmitCallback = (values: GiftMessageFormValues, formikHelpers: FormikHelpers<GiftMessageFormValues>) => void

export type onChangeCallback = (values: GiftMessageFormValues, formikErrors: FormikErrors<GiftMessageFormValues>) => void

export interface Props {
  onSubmit: OnSubmitCallback
  onChange?: onChangeCallback
  initialValues?: Partial<GiftMessageFormValues>
}

export const GiftMessageForm = ({ onSubmit, onChange, initialValues }: Props) => {
  const intl = useIntl()
  const id = useMemo(() => uuidv4(), [])

  return (
    <Formik
      initialValues={{
        ...schema,
        ...initialValues
      }}
      onSubmit={onSubmit}
      validationSchema={validation()}
      validateOnChange
    >
      <Form.Wrapper>
        <Form.FormikObserver<GiftMessageFormValues> onChange={onChange} autoSubmit />
        <Grid>
          <div>
            <Field
              id={`s-${id}`}
              name='sender'
              label={intl.formatMessage({
                id: 'giftMessage.label.sender'
              })}
              component={Form.Input}
            />
          </div>
          <div>
            <Field
              id={`r-${id}`}
              name='recipient'
              label={intl.formatMessage({
                id: 'giftMessage.label.recipient'
              })}
              component={Form.Input}
            />
          </div>
        </Grid>

        <Field
          id={`m-${id}`}
          name='message'
          label={intl.formatMessage({
            id: 'giftMessage.label.message'
          })}
          component={Form.TextArea}
        />
      </Form.Wrapper>
    </Formik>
  )
}
